module.exports = __webpack_public_path__ + "media/images/bnr_special_event2-af97ddd034dcd3ef12e5f250c8fd0536.jpg";